module.exports = "<div>\r\n  {{this.valor}}\r\n</div>\r\n"